import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { ApplicationFormPage } from './features/application/pages/application-form.page';
import { ApplicationListPage } from './features/application/pages/application-list.page';
import { ApplicationApprovalPage } from './features/application/pages/application-approval.page';
import { PaymentKnockOffPage } from './features/payment-knock-off/pages/payment-knock-off.page';
import { BillingCyclesPage } from './pages/billing-cycles.page';
import { ChargesPage } from './pages/charges.page';
import { ContractFormPage } from './pages/contract-form.page';
import { ContractListPage } from './features/contract/pages/contract-list.page';
import { ContractAnalysisPage } from './features/contract/pages/contract-analysis';
import { DashboardPage } from './pages/dashboard/dashboard.page';
import { LoaFormPage } from './features/loa/pages/loa-form.page';
import { LoaListPage } from './features/loa/pages/loa-list.page';
import { LoginPage } from './pages/login.page';
import { NotFoundPage } from './pages/not-found.page';
import { RatesPage } from './pages/rates.page';
import { UserManualPrototypePage } from './pages/user-manual-prototype.page';
import { StaffManagementPage } from './features/staff-management/pages/staff-management.page';
import { StaffPrivilegesPage } from './features/staff-management/pages/staff-privileges.page';
import { SopTmrBillingPage } from './features/sop-tmr-billing/pages/sop-tmr-billing.page';
import { CreditDebitNotePage } from './features/credit-debit-note/pages/credit-debit-note.page';
import { CreditDebitNoteListPage } from './features/credit-debit-note/pages/credit-debit-note-list.page';
import { OaBillingPage } from './features/oa-billing/pages/oa-billing.page';
import { BillVerificationPage } from './features/bill-verification/pages/bill-verification.page';
import { BillVerification1Page } from './features/bill-verification/pages/bill-verification1.page';
import { VendorDetailsPage } from './features/vendor/pages/vendor-details.page';
import { VendorDocumentConfigPage } from './features/vendor-document/pages/vendor-document-config.page';
import { VendorDocumentConfigFormPage } from './features/vendor-document/pages/vendor-document-config-form.page';
import { VendorFormPage } from './features/vendor/pages/vendor-form.page';
import { VendorUserPrivilegesPage } from './features/vendor/pages/vendor-user-privileges.page';
import { VendorsPage } from './features/vendor/pages/vendors.page';
import { MenuManagementPage } from './features/menu-management/pages/menu-management.page';
import { MenuAuditLogPage } from './features/menu-audit-log/pages/menu-audit-log.page';
import { McpReportsPage } from './features/mcp-reports/pages/mcp-reports.page';
import { ReaMatchingPage } from './features/rea-matching/pages/rea-matching.page';
import { ReaContractAnalysisPage } from './features/rea-contract-analysis/pages/rea-contract-analysis.page';
import { NerpcReaReportsPage } from './features/nerpc-rea-reports/pages/nerpc-rea-reports.page';
import { NrpcReaReportsPage } from './features/nrpc-rea-reports/pages/nrpc-rea-reports.page';
import { ReaReportsPage } from './features/rea-reports/pages/rea-reports.page';
import { WrpcReaReportsPage } from './features/wrpc-rea-reports/pages/wrpc-rea-reports.page';
import { BatteryConfigurationPage } from './features/bess/pages/battery-configuration.page';
import { BatteryStorageSystemPage } from './features/bess/pages/battery-storage-system.page';
import { SocMonitoringPage } from './features/bess/pages/soc-monitoring.page';
import { BessContractSupportPage } from './features/bess/pages/bess-contract-support.page';
import { BessFleetOperationsMatrixPage } from './features/bess/pages/bess-fleet-operations-matrix.page';
import { BessAiForecastPage } from './features/bess/pages/bess-ai-forecast.page';
import { DpmrReportPage } from './features/bess/pages/Report/dpmr-report.page';
import { ForecastMarketPricePage } from './features/bess/pages/forecast-market-price.page';
import { BessBidMonitorPage } from './features/bess/pages/bess-bid-monitor.page';
import { BessPlaceBidPage } from './features/bess/pages/bess-place-bid.page';
import { BessContractHedgingOptimizationPage } from './features/bess/pages/bess-contract-hedging-optimization.page';
import { ProfitLossReportPage } from './features/bess/pages/Report/profit-loss-report.page';
import { GridIndiaSchedulesPage } from './features/grid-india-schedules/pages/grid-india-schedules.page';
import { AllReaPage } from './features/all-rea/pages/all-rea.page';

export const routes: Routes = [
  { path: 'login', component: LoginPage },
  { path: '', component: DashboardPage, canActivate: [authGuard] },
  { path: 'user-manual', component: UserManualPrototypePage, canActivate: [authGuard] },
  { path: 'vendors', component: VendorsPage, canActivate: [authGuard] },
  { path: 'vendors/new', component: VendorFormPage, canActivate: [authGuard] },
  { path: 'vendors/:id/edit', component: VendorFormPage, canActivate: [authGuard] },
  { path: 'vendors/:id/users/:userId/privileges', component: VendorUserPrivilegesPage, canActivate: [authGuard] },
  { path: 'vendors/:id', component: VendorDetailsPage, canActivate: [authGuard] },
  { path: 'document-configurations', component: VendorDocumentConfigPage, canActivate: [authGuard] },
  { path: 'document-configurations/new', component: VendorDocumentConfigFormPage, canActivate: [authGuard] },
  { path: 'document-configurations/:id/edit', component: VendorDocumentConfigFormPage, canActivate: [authGuard] },
  { path: 'vendor-documents', redirectTo: 'document-configurations', pathMatch: 'full' },
  { path: 'vendor-documents/new', redirectTo: 'document-configurations/new', pathMatch: 'full' },
  { path: 'vendor-documents/:id/edit', redirectTo: 'document-configurations/:id/edit' },
  { path: 'loas', component: LoaListPage, canActivate: [authGuard] },
  { path: 'loas/new', component: LoaFormPage, canActivate: [authGuard] },
  { path: 'loas/:id/edit', component: LoaFormPage, canActivate: [authGuard] },
  { path: 'loas/:id', component: LoaFormPage, canActivate: [authGuard] },
  { path: 'charges', component: ChargesPage, canActivate: [authGuard] },
  { path: 'rates', component: RatesPage, canActivate: [authGuard] },
  { path: 'billing-cycles', component: BillingCyclesPage, canActivate: [authGuard] },
  { path: 'contracts', component: ContractListPage, canActivate: [authGuard] },
  { path: 'contracts/analysis', component: ContractAnalysisPage, canActivate: [authGuard] },
  { path: 'contract-analysis', redirectTo: 'contracts/analysis', pathMatch: 'full' },
  { path: 'contracts/new', component: ContractFormPage, canActivate: [authGuard] },
  { path: 'contracts/:id/edit', component: ContractFormPage, canActivate: [authGuard] },
  { path: 'contracts/:id', component: ContractFormPage, canActivate: [authGuard] },
  { path: 'applications', component: ApplicationListPage, canActivate: [authGuard] },
  { path: 'application-approvals', component: ApplicationApprovalPage, canActivate: [authGuard] },
  { path: 'payment-knock-off', component: PaymentKnockOffPage, canActivate: [authGuard] },
  { path: 'applications/new', component: ApplicationFormPage, canActivate: [authGuard] },
  { path: 'applications/:id/edit', component: ApplicationFormPage, canActivate: [authGuard] },
  { path: 'applications/:id', component: ApplicationFormPage, canActivate: [authGuard] },
  { path: 'sop-tmr-billing', component: SopTmrBillingPage, canActivate: [authGuard] },
  { path: 'oa-billing', component: OaBillingPage, canActivate: [authGuard] },
  { path: 'bill-verification', component: BillVerificationPage, canActivate: [authGuard] },
  { path: 'bill-verification1', component: BillVerification1Page, canActivate: [authGuard] },
  { path: 'credit-debit-notes', component: CreditDebitNoteListPage, canActivate: [authGuard] },
  { path: 'credit-debit-notes/new', component: CreditDebitNotePage, canActivate: [authGuard] },
  { path: 'credit-debit-notes/:id/edit', component: CreditDebitNotePage, canActivate: [authGuard] },
  { path: 'auto-fetch/all-rea', component: AllReaPage, canActivate: [authGuard] },
  { path: 'auto-fetch/mcp-reports', component: McpReportsPage, canActivate: [authGuard] },
  { path: 'auto-fetch/forecast-market-prices', component: ForecastMarketPricePage, canActivate: [authGuard] },
  { path: 'auto-fetch/grid-india-schedules', component: GridIndiaSchedulesPage, canActivate: [authGuard] },
  { path: 'auto-fetch/rea-reports', component: ReaReportsPage, canActivate: [authGuard] },
  { path: 'auto-fetch/nrpc-rea-reports', component: NrpcReaReportsPage, canActivate: [authGuard] },
  { path: 'auto-fetch/nerpc-rea-reports', component: NerpcReaReportsPage, canActivate: [authGuard] },
  { path: 'auto-fetch/wrpc-rea-reports', component: WrpcReaReportsPage, canActivate: [authGuard] },
  { path: 'rea-matching', component: ReaMatchingPage, canActivate: [authGuard] },
  { path: 'rea-contract-analysis', component: ReaContractAnalysisPage, canActivate: [authGuard] },
  { path: 'bess/battery-asset-management', component: BatteryConfigurationPage, canActivate: [authGuard] },
  {
    path: 'bess/soc-monitoring',
    component: SocMonitoringPage,
    canActivate: [authGuard],
  },
  {
    path: 'bess/contract-support',
    component: BessContractSupportPage,
    canActivate: [authGuard],
  },
  {
    path: 'bess/fleet-operations-matrix',
    component: BessFleetOperationsMatrixPage,
    canActivate: [authGuard],
  },
  {
    path: 'bess/ai-forecast',
    component: BessAiForecastPage,
    canActivate: [authGuard],
  },
  {
    path: 'bess/daily-performance-summary',
    component: DpmrReportPage,
    canActivate: [authGuard],
  },
  {
    path: 'bess/bid-monitor',
    component: BessBidMonitorPage,
    canActivate: [authGuard],
  },
  {
    path: 'bess/place-bid',
    component: BessPlaceBidPage,
    canActivate: [authGuard],
  },
  {
    path: 'bess/contract-hedging-optimization',
    component: BessContractHedgingOptimizationPage,
    canActivate: [authGuard],
  },
  {
    path: 'bess/profit-loss-report',
    component: ProfitLossReportPage,
    canActivate: [authGuard],
  },
  { path: 'bess/charge-discharge-scheduling', component: BatteryStorageSystemPage, canActivate: [authGuard] },
  { path: 'bess/battery-storage-system', redirectTo: 'bess/charge-discharge-scheduling', pathMatch: 'full' },
  { path: 'bess/battery-configuration', component: BatteryConfigurationPage, canActivate: [authGuard] },
  { path: 'staff', component: StaffManagementPage, canActivate: [authGuard] },
  { path: 'staff/:id/privileges', component: StaffPrivilegesPage, canActivate: [authGuard] },
  { path: 'menu-management', component: MenuManagementPage, canActivate: [authGuard] },
  { path: 'menu-audit-logs', component: MenuAuditLogPage, canActivate: [authGuard] },
  { path: '**', component: NotFoundPage },
];
